// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config';
// components

// ----------------------------------------------------------------------


export default function Main({ children, sx, ...other }: BoxProps) {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        maxWidth: isDesktop ? '100%' : '1000px',
        width: '100%',
        position: 'relative',
        flexGrow: 1,
        py: isDesktop ? 0 : `${/*HEADER.H_MOBILE + */HEADER.SPAICING + 20}px`,
        pb: 0,
        // py: `${HEADER.H_MOBILE + HEADER.SPAICING}px`, TODO fix
        ...(isDesktop && {
          // px: 2,
          // py: `${HEADER.H_DASHBOARD_DESKTOP + HEADER.SPAICING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
